import { render } from "./ProjectCardRwa.vue?vue&type=template&id=1dabce03&scoped=true"
import script from "./ProjectCardRwa.vue?vue&type=script&lang=js"
export * from "./ProjectCardRwa.vue?vue&type=script&lang=js"

import "./ProjectCardRwa.vue?vue&type=style&index=0&id=1dabce03&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dabce03"]])

export default __exports__